import { config } from "../../common/consts/config";
import { File } from "../../common/types/Data/File";

export const buildFileOptionalCdnUri = (file?: File): string => {
    return file ? `${config.s3CloudfrontUrl}/${file.path}` : "";
};
